<script setup lang="ts">
import {onMounted} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {useAuthStore} from "@/stores";
import {parseState} from "@/utils";
import {storeToRefs} from "pinia";

const route = useRoute();
const router = useRouter();

onMounted(async () => {

  const authStore = useAuthStore();
  const {authError, authErrorDescription} = storeToRefs(authStore);

  try {
    const code = route.query.code as string;
    const state = route.query.state as string;
    const error = route.query.error as string;
    const error_description = route.query.error_description as string;
    const reauth = route.query.reauth as string;

    // if the password was reset, we'll land here and kick off an entirely new login flow
    if (reauth === "true") {
      console.log("Relogin requested. Redirecting to login...");
      const parsedState = parseState(state);
      authStore.login({targetUrl: parsedState.targetUrl}).then(() => {});
      return;
    }

    if (error) {
      console.error('OAuth error:', error, error_description);
      authError.value = error;
      authErrorDescription.value = error_description || 'An unknown error occurred during authentication.';
      router.replace(`/autherror`).then(() => {});
      return;
    }

    const redirect = await authStore.handleCallback(code, state);
    router.replace(redirect).then(() => {});
  } catch (err: any) {
    console.error('OAuth callback failed:', err);
    authErrorDescription.value = 'An unknown error occurred during authentication.';
    router.replace(`/autherror`).then(() => {});
  }
});
</script>

<template>
  <p>Signing you in...</p>
</template>